/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:18
 * @LastEditTime: 2021-09-07 17:21:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Meta from 'vue-meta'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/css/element-variables.scss'
import './assets/css/index.css'
import './assets/css/_qiniu-play.scss'
// Vue.use(VueAwesomeSwiper)

import yqComponent from './pages/component'
import accountActivation from './pages/component/AccountActivation'
import './plugins/element.js'
import './permission'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Viewer.setDefaults({
	Options: {
		'toolbar': false,
	}
})

Vue.config.productionTip = false
Vue.use(yqComponent)
Vue.use(accountActivation)
Vue.use(Meta)
Vue.use(Viewer)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
